<template>
    <div class="top-value-alert" v-show="show">
      <hp5-alert type="info" hide-alert-text :show-alert="true">
        <div class="top-value-content">
          <hp5-icon name="brand-trophy-2" size="lg"></hp5-icon>
          <div v-show="isHospitalBadge">
            <hp5-heading tag-selection="h3" size-selection="medium">Choose Top Value now</hp5-heading>
            <div class="hospital">
              <hp5-semantic size-selection="xs">
                <span>You may save more when you choose a Top Value </span><span><a :href="hospitalUrl">hospital</a></span
                ><span> for your procedure. </span>
                <span><a href="top-value-learn-more">Learn more about Top Value</a>.</span>
              </hp5-semantic>
            </div>
          </div>
          <div v-show="isClinicBadge">
            <hp5-heading tag-selection="h3" size-selection="medium">Choose Top Value now</hp5-heading>
            <div class="hospital">
              <hp5-semantic size-selection="xs">
                <span>You may save more when you choose a Top Value </span><span><a :href="clinicUrl">clinic</a></span
                ><span> for your procedure. </span>
                <span><a href="top-value-learn-more">Learn more about Top Value</a>.</span>
              </hp5-semantic>
            </div>
          </div>
          <div v-show="isBothBadge">
            <hp5-heading tag-selection="h3" size-selection="medium">Choose Top Value now</hp5-heading>
            <div class="hospital">
              <hp5-semantic size-selection="xs">
                <span>You may save more when you choose a Top Value </span
                ><span><a :href="hospitalUrl">hospital</a> or <a :href="clinicUrl">clinic</a></span
                ><span> for your procedure. </span>
                <span><a href="top-value-learn-more">Learn more about Top Value</a>.</span>
              </hp5-semantic>
              <hp5-spacing-vertical xs="xs"></hp5-spacing-vertical>
            </div>
          </div>
          <div>
            <hp5-call-to-action type="secondary" icon-name="brand-apartment">
              <a :href="directoryUrl" aria-label="External Link aria-label" target="_blank">
                <span>View the full provider list</span>
              </a>
            </hp5-call-to-action>
          </div>
        </div>
      </hp5-alert>
    </div>
</template>
  
<script setup>

      const { recommendedBadgeType, betterChoiceContext, profile, context, searchResults } = useFCPModel()
      const { buildUrl } = useUrls(context.value)
      const { getBadgeTypesInResults } = useBadges()
      const isHospitalBadge = computed(() => recommendedBadgeType.value == 'hospital')
      const isClinicBadge = computed(() => recommendedBadgeType.value == 'clinic')
      const isBothBadge = computed(() => recommendedBadgeType.value == 'both')
      const directoryUrl = computed(() => buildUrl('/fcp/top-value-directory/', { betterChoiceContext: betterChoiceContext.value }))
      const clinicUrl = computed(() => buildUrl('/fcp/csearch', { type: 'medical' }))
      const hospitalUrl = computed(() => buildUrl('/fcp/csearch', { type: 'hospital' }))
      const isNotPractitioner = computed(() => (context.value.type != 'doctor' && context.value.type != 'dentist' ? true : false))
  
      //Among other conditions, the top value alert should only be displayed if the search results
      //contain at least one result with a betterChoiceCategory attribute value of "HVN"
      //Here, we're using an existing method from the use-sort composition function that aggregates all of the betterChoiceCategory
      //attribute values found in the current search results and checking to see if there's a result with the "HVN" attribute
      const hasHVN = computed(() => {
        const badgeTypes = getBadgeTypesInResults(searchResults.value)
        return badgeTypes.includes('HVN')
      })
  
      const show = computed(() =>
        hasHVN.value && isNotPractitioner.value && recommendedBadgeType.value && profile.value.shouldShowTopValue ? true : false
      )
</script>
  
<style scoped lang="scss">
@use '~/assets/scss/breakpoints'  as *;
  
  .top-value-content {
    display: grid;
    grid-template-columns: auto;
  }
  @include small-up {
    .top-value-content {
      display: grid;
      grid-template-columns: 1fr 8fr 3fr;
      column-gap: var(--spacing-sm);
    }
  }
  
  hp5-icon {
    fill: var(--color-info-base);
    justify-self: center;
  }
  </style>
  
  <style lang="scss">
  .top-value-content {
    h3 {
      padding-top: 0 !important;
      margin-top: 0 !important;
    }
  }
</style>